import { useEffect, useState } from "react";
import { customFetch } from "@workspace/api-client-react";

export function useAuthenticatedBlobUrl(apiPath: string | null | undefined) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(!!apiPath);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!apiPath) {
      setBlobUrl(null);
      setLoading(false);
      setError(false);
      return;
    }

    let revoked = false;
    let objectUrl: string | null = null;
    setLoading(true);
    setError(false);
    setBlobUrl(null);

    void customFetch<Blob>(apiPath, { responseType: "blob" })
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        if (!revoked) {
          setBlobUrl(objectUrl);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!revoked) {
          setError(true);
          setLoading(false);
        }
      });

    return () => {
      revoked = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [apiPath]);

  return { blobUrl, loading, error };
}
